import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useCountryReducer = () =>
  useSelector((state: ApplicationState) => state.country);
